module.exports = __webpack_public_path__ + "img/bombero_up_selected.06ab3224.svg";